var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$store.state.Deadline.rdDiff !== Infinity &&
    !_vm.$store.getters.isRdOver
    ? _c(
        "div",
        {
          staticClass: "_component-welfare",
          class: { hide: !_vm.$store.state.isShowWelfare }
        },
        [
          _c("div", { staticClass: "content-wrap" }, [
            _c("div", {
              staticClass: "icon-close",
              on: { click: _vm.handleClickClose }
            }),
            _c("div", { staticClass: "text-1 h3" }, [
              _vm._v("完善信息后解锁《名校早知道》精华视频")
            ]),
            _vm._m(0),
            !_vm.modal
              ? _c("div", { staticClass: "qr-wrap img-wrap pc-only" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "//hsylc.oss-cn-hangzhou.aliyuncs.com/2026/qr/qr-5.png",
                      alt: ""
                    }
                  })
                ])
              : _vm._e()
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "text2 color-white" }, [
      _vm._v(" 了解诺奖教授和哈佛学霸的Secret of Success"),
      _c("br"),
      _vm._v(" 添加峰会小助手解锁福利，第一时间获取峰会相关动态 ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }